import {createMultiPathSVG, createStrokeSVG} from './TEMPLATE'

// iconoir: bookmark
export const Bookmark = createStrokeSVG({
  paths: [
    'M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// iconoir: bookmark
export const BookmarkDeleteLarge = createStrokeSVG({
  paths: [
    'M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z',
  ],
  viewBox: '2 2 20 20',
  strokeWidth: 1.5,
})

// iconoir: bookmark (fill weight)
export const BookmarkFilled = createMultiPathSVG({
  paths: [
    'M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z',
  ],
  viewBox: '0 0 24 24',
})
